<template>
	<div class="job-details-delivery_options">
		
		<div v-if="getCurrentGroup(
			[$store.state.constants.SILA_JOB_TYPE_PRINT])">
			<div :class="['subsection']">
				<div class="subsection__title">
					<h4 class="title">Delivery Type</h4>
					<p>All materials will be delivered to PPM</p>
				</div>
				<div class="subsection__content">
					<div class="job-details__type-options">
						<v-radio-group
							row
							:class="[{'input-disabled':!editable}]"
							v-model="optionFileRelease">
							<div class="radio-item">
								<v-radio
									label="Standard Release"
									:value="$store.state.constants.SILA_JOB_PRINT_DELIVERY_TYPE_STANDARD"/>
								<div>
									<ul>
										<li>Working InDesign CC files</li>
										<li>Fullsize or tabloid prints</li>
									</ul>
								</div>
							</div>

							<div class="radio-item">
								<v-radio
									label="Fabric Release"
									:value="$store.state.constants.SILA_JOB_PRINT_DELIVERY_TYPE_FABRIC"/>
								<div>
									<ul>
										<li>Working InDesign CC files</li>
										<li>Fullsize or tabloid prints</li>
										<li>Print ready PDF files at 150 dpi</li>
										<li>File include 1" bleed all sides for stitching</li>
									</ul>
								</div>
							</div>
						</v-radio-group>
					</div>
				</div>
			</div>
			<div :class="['subsection']">
				<div class="subsection__title">
					<h4 class="title">Additional Delivery Requests</h4>
				</div>
				<div class="subsection__content job-details__requests">
					<div class="requests__options">
						<h4 class="subheading"></h4>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="Hi-Res PDF"
							v-model="optionHiResPDF"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="Hi-Res JPEG"
							v-model="optionHiResJPEG"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="Hi-Res TIFF"
							v-model="optionHiResTIFF"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							v-if="department === 'Retail'"
							color="primary"
							:height="4"
							label="Working Files (requires approval)"
							v-model="optionWorkingFilesForPrint"/>
					</div>
					<div
						v-if="optionHiResPDF"
						class="requests__specs">
						<h4 class="subheading">Hi-Res PDF Specs</h4>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="Dielines On"
							v-model="optionDielines"/>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="With Crops"
							v-model="optionCrops"/>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="Full Bleed"
							v-model="optionFullBleed"/>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="Slug"
							v-model="optionSlug"/>
					</div>
				</div>
			</div>
		</div>


		<div v-if="getCurrentGroup(
			[$store.state.constants.SILA_JOB_TYPE_AD,
			$store.state.constants.SILA_JOB_TYPE_ART_ONLY,
			$store.state.constants.SILA_JOB_TYPE_OTHER,
			$store.state.constants.SILA_JOB_TYPE_PHOTOGRAPHY,
			$store.state.constants.SILA_JOB_TYPE_RETOUCHING])">
			<div :class="['subsection']">
				<div class="subsection__title">
					<h4 class="title">Additional Delivery Requests</h4>
				</div>
				<div class="subsection__content job-details__requests">
					<div class="requests__options">
						<h4 class="subheading"></h4>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="Working InDesign CC Files"
							v-model="optionWorkingFilesIndd"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="Working IDML Files"
							v-model="optionWorkingFilesIDML"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="Hi-Res PDF"
							v-model="optionHiResPDF"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="Hi-Res JPEG"
							v-model="optionHiResJPEG"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="Hi-Res TIFF"
							v-model="optionHiResTIFF"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="EPS file for Vector logo"
							v-model="optionVectorEPS"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="Other"
							v-model="optionOther"/>
					</div>
					<div
						v-if="optionHiResPDF"
						class="requests__specs">
						<h4 class="subheading">Hi-Res PDF Specs</h4>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="Dielines On"
							v-model="optionDielines"/>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="With Crops"
							v-model="optionCrops"/>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="Full Bleed"
							v-model="optionFullBleed"/>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="Slug"
							v-model="optionSlug"/>
					</div>
				</div>
			</div>
			<div :class="['subsection']">
				<div class="subsection__title">
					<h4 class="title">Special Delivery</h4>
				</div>
				<div class="subsection__content job-details__requests">
					<div class="requests__options">
						<h4 class="subheading"></h4>
						<v-checkbox class="special_delivery"
							:class="[{'input-disabled':!editable}]"
							color="primary"
							label="Requires CUSTOM/PREMIERE FTP with upload confirmation to vendor"
							:height="4"
							v-model="optionSpecialDelivery" />
					</div>
				</div>
			</div>
		</div>


		<div v-if="getCurrentGroup(
			[$store.state.constants.SILA_JOB_TYPE_WEB])">
			<div :class="['subsection']">
				<div class="subsection__title">
					<h4 class="title">Additional Delivery Requests</h4>
				</div>
				<div class="subsection__content job-details__requests">
					<div class="requests__options">
						<h4 class="subheading"></h4>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="JPEG"
							v-model="optionWebJPEG"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="PDF"
							v-model="optionWebPDF"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="Layered PSD"
							v-model="optionWebPSD"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="FTP Link - JPEGs"
							v-model="optionFTPLinkJPEG"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="FTP Link - Working Files"
							v-model="optionFTPLinkWorkingFiles"/>
						<v-checkbox
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="4"
							label="Coded HTML Link"
							v-model="optionHTMLLink"/>
					</div>
					<div
						v-if="optionHiResPDF"
						class="requests__specs">
						<h4 class="subheading">Hi-Res PDF Specs</h4>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="Dielines On"
							v-model="optionDielines"/>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="With Crops"
							v-model="optionCrops"/>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="Full Bleed"
							v-model="optionFullBleed"/>
						<v-switch
							:class="[{'input-disabled':!editable}]"
							color="primary"
							:height="6"
							label="Slug"
							v-model="optionSlug"/>
					</div>
				</div>
			</div>
		</div>


		<div v-if="getCurrentGroup(
			[$store.state.constants.SILA_JOB_TYPE_MULTIMEDIA])">
			<div :class="['subsection']">
				<div class="subsection__title">
					<h4 class="title">Delivery Type</h4>
				</div>
				<div class="subsection__content">
					<div class="job-details__type-options">
                        <v-checkbox
                                :class="[{'input-disabled':!editable}]"
                                color="primary"
                                :height="4"
                                label="Drop FTP"
                                v-model="optionMultimediaDropFTP"/>
                        <v-checkbox
                                :class="[{'input-disabled':!editable}]"
                                color="primary"
                                :height="4"
                                label="Account FTP"
                                v-model="optionMultimediaAccountFTP"/>  
					</div>
				</div>
			</div>
		</div>

	</div>
</template>


<script>
	import { mapState, mapGetters, mapActions } from 'vuex'

	export default {
		name: 'job-details-delivery_options',

		props: {
			type: {
				required: true,
				default: ''
			},
			department: {
				required: true,
				default: ''
			},
			dataSet: {
				type: String,
				required: false,
				default: 'job' // job or createJob
			},
			editable: {
				type: Boolean, 
				required: false,
				default: false
			}
		},

		computed: {
			...mapState({
				jobData: state => state.jobs.job,
				createJobData: state => state.jobs.createJob_Data
			}),

			getDataSet() {
				return (this.dataSet === 'job' ) 
					? 'jobData' 
					: 'createJobData'
			},
			getStoreAction() { 
				return (this.dataSet === 'job' ) 
					? 'VUEX_JOB_UPDATE_DELIVERY_OPTION_PROP' 
					: 'VUEX_JOB_CREATE_UPDATE_DELIVERY_OPTION_PROP'
			},
			getCurrentGroup() {
				return((val) => {
					if (!this.type) return false
					let match = (val.indexOf(this.type) != -1) ? true : false
					return match 
				})
			},


			optionFileRelease: {
				get() { return this[this.getDataSet].delivery_options.print_delivery_type },
				set(val) { this.$store.dispatch( this.getStoreAction, { print_delivery_type:val }) }
			},
			
			optionHiResPDF: {
				get() { return this[this.getDataSet].delivery_options.hires_pdf },
				set(val) {
					let props = {
						hires_pdf: val,
						hires_pdf_dielines: false,
						hires_pdf_cropmarks: false,
						hires_pdf_fullbleed: false,
						hires_pdf_slug: false
					}

					this.$store.dispatch( this.getStoreAction, { ...props })
				}
			},
			optionHiResJPEG: {
				get() { return this[this.getDataSet].delivery_options.hires_jpeg },
				set(val) { this.$store.dispatch( this.getStoreAction, { hires_jpeg:val }) }
			},
			optionHiResTIFF: {
				get() { return this[this.getDataSet].delivery_options.hires_tiff },
				set(val) { this.$store.dispatch( this.getStoreAction, { hires_tiff:val }) }
			},
			optionVectorEPS: {
				get() { return this[this.getDataSet].delivery_options.vector_eps },
				set(val) { this.$store.dispatch( this.getStoreAction, { vector_eps:val }) }
			},
			optionWorkingFilesForPrint: {
				get() { return this[this.getDataSet].delivery_options.working_files_for_print },
				set(val) { this.$store.dispatch( this.getStoreAction, { working_files_for_print:val }) }
			},
			optionWorkingFilesIndd: {
				get() { return this[this.getDataSet].delivery_options.working_indd_files },
				set(val) { this.$store.dispatch( this.getStoreAction, { working_indd_files:val }) }
			},
			optionWorkingFilesIDML: {
				get() { return this[this.getDataSet].delivery_options.working_idml_files },
				set(val) { this.$store.dispatch( this.getStoreAction, { working_idml_files:val }) }
			},
			optionOther: {
				get() { return this[this.getDataSet].delivery_options.other },
				set(val) { this.$store.dispatch( this.getStoreAction, { other:val }) }
			},
			optionWebJPEG: {
				get() { return this[this.getDataSet].delivery_options.web_jpeg },
				set(val) { this.$store.dispatch( this.getStoreAction, { web_jpeg:val }) }
			},
			optionWebPDF: {
				get() { return this[this.getDataSet].delivery_options.web_pdf },
				set(val) { this.$store.dispatch( this.getStoreAction, { web_pdf:val }) }
			},
			optionWebPSD: {
				get() { return this[this.getDataSet].delivery_options.web_psd },
				set(val) { this.$store.dispatch( this.getStoreAction, { web_psd:val }) }
			},
			optionFTPLinkJPEG: {
				get() { return this[this.getDataSet].delivery_options.web_ftp_jpeg },
				set(val) { this.$store.dispatch( this.getStoreAction, { web_ftp_jpeg:val }) }
			},
			optionFTPLinkWorkingFiles: {
				get() { return this[this.getDataSet].delivery_options.web_ftp_working_files },
				set(val) { this.$store.dispatch( this.getStoreAction, { web_ftp_working_files:val }) }
			},
			optionHTMLLink: {
				get() { return this[this.getDataSet].delivery_options.web_html },
				set(val) { this.$store.dispatch( this.getStoreAction, { web_html:val }) }
			},

			optionDielines: {
				get() { return this[this.getDataSet].delivery_options.hires_pdf_dielines },
				set(val) { this.$store.dispatch( this.getStoreAction, { hires_pdf_dielines:val }) }
			},
			optionCrops: {
				get() { return this[this.getDataSet].delivery_options.hires_pdf_cropmarks },
				set(val) { this.$store.dispatch( this.getStoreAction, { hires_pdf_cropmarks:val }) }
			},
			optionFullBleed: {
				get() { return this[this.getDataSet].delivery_options.hires_pdf_fullbleed },
				set(val) { this.$store.dispatch( this.getStoreAction, { hires_pdf_fullbleed:val }) }
			},
			optionSlug: {
				get() { return this[this.getDataSet].delivery_options.hires_pdf_slug },
				set(val) { this.$store.dispatch( this.getStoreAction, { hires_pdf_slug:val }) }
			},

			optionSpecialDelivery: {
				get() { return this[this.getDataSet].delivery_options.requires_custom_ftp },
				set(val) { this.$store.dispatch( this.getStoreAction, { requires_custom_ftp:val }) }
			},
            optionMultimediaDropFTP: {
                get() { return this[this.getDataSet].delivery_options.multimedia_drop_ftp },
                set(val) { this.$store.dispatch( this.getStoreAction, { multimedia_drop_ftp:val }) }
            },
            optionMultimediaAccountFTP: {
                get() { return this[this.getDataSet].delivery_options.multimedia_account_ftp },
                set(val) { this.$store.dispatch( this.getStoreAction, { multimedia_account_ftp:val }) }
            },
		},

		mounted() {

		},

		methods: {

		}

	}
</script>